const PlanEndpoints = {
  get: {
    method: 'GET',
    url: (id: string) => `/plans/${id}`,
  },
  getDetails: {
    method: 'GET',
    url: (id: string) => `/plans/${id}/details`,
  },
  getMembers: {
    method: 'GET',
    url: (id: string) => `/plans/${id}/members`,
  },
  addMembers: {
    method: 'POST',
    url: (id: string) => `/plans/${id}/add-members`,
  },
  inviteMembers: {
    method: 'POST',
    url: (id: string) => `/plans/${id}/invite-members`,
  },
  verifyInvite: {
    method: 'GET',
    url: (inviteToken: string) => `/plans/verify/${inviteToken}`,
  },
  acceptInvite: {
    method: 'POST',
    url: () => `/plans/accept-invite`,
  },
  removeMembers: {
    method: 'POST',
    url: (id: string) => `/plans/${id}/remove-members`,
  },
  manageMembers: {
    method: 'PATCH',
    url: (id: string) => `/plans/${id}/manage-members`,
  },
  suggestMembers: {
    method: 'POST',
    url: (id: string) => `/plans/${id}/suggest-emails`,
  },
  removeSuggestedMembers: {
    method: 'POST',
    url: (id: string) => `/plans/${id}/remove-suggested-emails`,
  },
  removeInvitedEmails: {
    method: 'POST',
    url: (id: string) => `/plans/${id}/remove-invited-emails`,
  },
  pendingInvites: {
    method: 'GET',
    url: (id: string) => `/plans/${id}/pending-invitations`,
  },
  suggestedMembers: {
    method: 'GET',
    url: (id: string) => `/plans/${id}/suggested-emails`,
  },
  cancel: {
    method: 'POST',
    url: (id: string) => `/plans/${id}/cancel`,
  },
} as const;

type PlanEndpoints = typeof PlanEndpoints;

export type { PlanEndpoints };
export default PlanEndpoints;
